// extracted by mini-css-extract-plugin
export default {"heading":"PaymentMethodLimits_heading__zEkYg","row":"PaymentMethodLimits_row__l5H+I","label":"PaymentMethodLimits_label__asWY4","value":"PaymentMethodLimits_value__cL1PH"};